import { TextbookModifications } from './textbook.modifications';

const modifications = [TextbookModifications];

export { modifications, TextbookModifications };
